import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createProduct = (params) => {
  return Api(ENDPOINTS.PRODUCT.CREATE, params, requestType.POST);
};

const updateProduct = (id, params) => {
  return Api(
    ENDPOINTS.PRODUCT.UPDATE.replace(":id", id),
    params,
    requestType.PUT,
  );
};

const updateProductStatus = (id, params) => {
  return Api(
    ENDPOINTS.PRODUCT.UPDATE_STATUS.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const updateProductFeaturedStatus = (id, params) => {
  return Api(
    ENDPOINTS.PRODUCT.UPDATE_FEATURED_STATUS.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const updateProductMegaDiscountStatus = (id, params) => {
  return Api(
    ENDPOINTS.PRODUCT.UPDATE_MEGA_DISCOUNT_STATUS.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const getSingleProductById = (id) => {
  return Api(
    ENDPOINTS.PRODUCT.SINGLE_PRODUCT_BY_ID.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getSingleProductBySlug = (slug) => {
  return Api(
    ENDPOINTS.PRODUCT.SINGLE_PRODUCT_BY_SLUG.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const getAllProducts = (query) => {
  const ENDPOINT = ENDPOINTS.PRODUCT.GET_ALL_PRODUCTS;

  const queryParams = new URLSearchParams();
  if (query.search) queryParams.append("search", query.search);
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  if (query.categoryId) queryParams.append("categoryId", query.categoryId);
  if (query.subCategoryId)
    queryParams.append("subCategoryId", query.subCategoryId);
  if (query.subSubCategoryId)
    queryParams.append("subSubCategoryId", query.subSubCategoryId);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);
  if (query.solutionType)
    queryParams.append("solutionType", query.solutionType);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

const getProductReviews = (query) => {
  const ENDPOINT = ENDPOINTS.PRODUCT.GET_ALL_PRODUCTS_REVIEWS;
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  if (query.search) queryParams.append("search", query.search);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;
  return Api(finalUrl, null, requestType.GET);
};

const supplierGetAllProduct = (id, query) => {
  const queryParams = new URLSearchParams();
  if (query.search) {
    queryParams.append("search", query.search);
  }
  if (query.categoryId) {
    queryParams.append("categoryId", query.categoryId);
  }
  if (query.subCategoryId) {
    queryParams.append("subCategoryId", query.subCategoryId);
  }
  if (query.subSubCategoryId) {
    queryParams.append("subSubCategoryId", query.subSubCategoryId);
  }
  if (query.page) {
    queryParams.append("page", query.page);
  }
  if (query.limit) {
    queryParams.append("limit", query.limit);
  }
  if (query.solutionType) {
    queryParams.append("solutionType", query.solutionType);
  }

  const finalUrl = queryParams.toString()
    ? `${endPoints.supplierGetAllProducts}/${id}?${queryParams.toString()}`
    : `${endPoints.supplierGetAllProducts}/${id}`;

  return Api(finalUrl, null, requestType.GET);
};

const supplierUpdateProfile = (id, params) => {
  return Api(
    `${endPoints.supplierUpdateProfile}/${id}`,
    params,
    requestType.PUT,
  );
};

const searchProductBySku = (sku) => {
  return Api(
    ENDPOINTS.PRODUCT.SEARCH_PRODUCT_BY_SKU.replace(":sku", sku),
    null,
    requestType.GET,
  );
};

const restockProduct = (id, params) => {
  return Api(
    ENDPOINTS.PRODUCT.RESTOCK_PRODUCT.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const getInventoryMovements = (params) => {
  const url = ENDPOINTS.PRODUCT.GET_INVENTORY_MOVEMENTS;
  const queryParams = new URLSearchParams();
  if (params.supplierId) queryParams.append("supplierId", params.supplierId);
  if (params.search) queryParams.append("search", params.search);
  if (params.movementType) queryParams.append("reason", params.movementType);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const updateVariantStatus = (id, variantId, params) => {
  return Api(
    ENDPOINTS.PRODUCT.UPDATE_VARIANT_STATUS.replace(":id", id).replace(
      ":variantId",
      variantId,
    ),
    params,
    requestType.PATCH,
  );
};

const deleteProduct = (id) => {
  return Api(
    ENDPOINTS.PRODUCT.DELETE.replace(":id", id),
    null,
    requestType.DELETE,
  );
};

const exportInventoryMovements = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  return Api(
    `${ENDPOINTS.PRODUCT.EXPORT_INVENTORY_MOVEMENTS}?${queryParams.toString()}`,
    null,
    requestType.GET,
  );
};

const exportProducts = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  return Api(
    `${ENDPOINTS.PRODUCT.EXPORT_PRODUCTS}?${queryParams.toString()}`,
    null,
    requestType.GET,
  );
};

const exportProductReviews = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  const finalUrl = queryParams.toString()
    ? `${ENDPOINTS.PRODUCT.EXPORT_PRODUCT_REVIEWS}?${queryParams.toString()}`
    : `${ENDPOINTS.PRODUCT.EXPORT_PRODUCT_REVIEWS}`;
  return Api(finalUrl, null, requestType.GET);
};

const getAllProductsList = (params) => {
  const queryParams = new URLSearchParams();

  queryParams.append("status", true);
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.categoryId) queryParams.append("categoryId", params.categoryId);
  if (params.subCategoryId)
    queryParams.append("subCategoryId", params.subCategoryId);
  if (params.subSubCategoryId)
    queryParams.append("subSubCategoryId", params.subSubCategoryId);

  const url = queryParams.toString()
    ? `${ENDPOINTS.PRODUCT.LIST_ALL_PRODUCTS}?${queryParams.toString()}`
    : ENDPOINTS.PRODUCT.LIST_ALL_PRODUCTS;

  return Api(url, null, requestType.GET);
};

export {
  createProduct,
  updateProduct,
  updateProductStatus,
  updateProductFeaturedStatus,
  updateProductMegaDiscountStatus,
  getSingleProductById,
  getSingleProductBySlug,
  getAllProducts,
  supplierGetAllProduct,
  supplierUpdateProfile,
  getProductReviews,
  searchProductBySku,
  restockProduct,
  getInventoryMovements,
  updateVariantStatus,
  deleteProduct,
  exportInventoryMovements,
  exportProducts,
  exportProductReviews,
  getAllProductsList,
};
